import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  cloudChiprApi,
  PutUsersMeAccountsByAccountIdResourcesApiArg,
} from "../../../../services/cloudchipr.api";
import { RootState } from "@/store/store";
import { updateGridResourceDataThunk } from "@/store/resources-grid/thunks/data/updateGridResourceDataThunk";
import { gridResourcesCurrentCleanResourcesGroupedByAccountIdSelector } from "@/store/resources-grid/selectors/clean/resources/gridResourcesCurrentCleanResourcesGroupedByAccountIdSelector";
import { gridResourcesCurrentCleanActionSelector } from "@/store/resources-grid/selectors/clean/gridResourcesCurrentCleanActionSelector";
import {
  setResourceGridCurrentCleanDetails,
  setResourcesGridCleanProcesses,
} from "@/store/resources-grid/resourcesGridSlice";
import { gridResourcesCurrentCleanMasterGridIdSelector } from "@/store/resources-grid/selectors/clean/gridResourcesCurrentCleanMasterGridIdSelector";
import { ResourcesGridCleanProcess } from "@/store/resources-grid/utils/types/clean";
import { gridResourcesCurrentCleanResourceTypeSelector } from "@/store/resources-grid/selectors/clean/resource-related/gridResourcesCurrentCleanResourceTypeSelector";
import { getLiveUsageResourceMetadataThunk } from "@/store/live-usage-mgmt/thunks/resources/resource-metadata/getLiveUsageResourceMetadataThunk";
import { generateCleanData } from "@/store/resources-grid/utils/helpers/clean/generateCleanData";

export const cleanGridSelectedResourcesThunk = createAsyncThunk(
  "resourcesGrid/cleanGridSelectedResources",
  async (_: void, { dispatch, getState }) => {
    const state = getState() as RootState;

    const resourcesForCleanGroupedByAccountId =
      gridResourcesCurrentCleanResourcesGroupedByAccountIdSelector(state);

    const cleanAction = gridResourcesCurrentCleanActionSelector(state);

    if (!resourcesForCleanGroupedByAccountId || !cleanAction) {
      return;
    }

    const accountIds = Object.keys(resourcesForCleanGroupedByAccountId ?? {});

    const { putUsersMeAccountsByAccountIdResources } = cloudChiprApi.endpoints;

    const promises = accountIds?.map((accountId) => {
      const resources = resourcesForCleanGroupedByAccountId[accountId];
      const body = generateCleanData(resources, cleanAction);

      const request: PutUsersMeAccountsByAccountIdResourcesApiArg = {
        accountId,
        body: body,
      };

      return dispatch(
        putUsersMeAccountsByAccountIdResources.initiate(request),
      ).unwrap();
    });

    if (!promises) {
      return;
    }

    const responses = await Promise.all(promises);

    const resourceType = gridResourcesCurrentCleanResourceTypeSelector(state);

    const masterGridId = gridResourcesCurrentCleanMasterGridIdSelector(state);

    const cleanProcesses = responses.map((item) => ({
      cleanAction,
      resourceType,
      masterGridId,
      executionId: item?.execution_id,
    })) as ResourcesGridCleanProcess[];

    dispatch(setResourcesGridCleanProcesses(cleanProcesses));

    if (masterGridId) {
      dispatch(updateGridResourceDataThunk(masterGridId));
    }

    dispatch(setResourceGridCurrentCleanDetails(null));
    if (resourceType) {
      await dispatch(getLiveUsageResourceMetadataThunk(resourceType));
    }
  },
);
